import { render } from "./ProfileCard.vue?vue&type=template&id=6ca8ffc0"
import script from "./ProfileCard.vue?vue&type=script&lang=js"
export * from "./ProfileCard.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./ProfileCard.vue?vue&type=style&index=0&id=6ca8ffc0&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script